import { formatCurrency } from "../../../services/functions"
import { TableRowDetailPageType } from "../types"

export default function TableRowDetailPage({
    pos,
    description,
    descriptionDetail,
    amount,
    unit,
    singleprice,
    tax,
    optional,
}: TableRowDetailPageType) {
    return (
        <tr className="z-0 border-b border-gray-200 text-sm relative overflow-hidden">
            <td className="table-cell">
                <p className="">
                    {pos} {optional && <span className="text-gray-300">(Optional)</span>}
                </p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-2">
                    {description} <br /> <span className="text-xs text-gray-400">{descriptionDetail}</span>
                </p>
            </td>
            <td className="table-cell">
                <p className="text-center line-clamp-1">{amount}</p>
            </td>
            <td className="table-cell">
                <p className="text-center line-clamp-1">{unit}</p>
            </td>
            <td className="table-cell">
                <p className="text-center line-clamp-1">{formatCurrency(singleprice)}</p>
            </td>
            <td className="table-cell">
                <p className="text-center line-clamp-1">{tax} %</p>
            </td>
        </tr>
    )
}
